import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg } from "./crmUtil";

const RESOURCE = { lead: "lead", opportunity: "opportunity", contact: "contact", account: "account" };

// Owner / assignee / priority for a CRM record. Only users whose role can see the record type are offered.
export default function AssignmentCard({ entity, id, record, onSaved }) {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ owner_id: record?.owner_id || "", assignee_id: record?.assigned_to || "", priority: record?.priority || "normal" });
  const [msg, setMsg] = useState({ ok: "", err: "" });
  useEffect(() => { api.get(`/crm/assignable-users?resource=${RESOURCE[entity]}`).then((r) => setUsers(r.data)).catch(() => setUsers([])); }, [entity]);
  const save = async (e) => {
    e.preventDefault();
    const body = { priority: form.priority, ...(form.owner_id && { owner_id: form.owner_id }), ...(form.assignee_id && { assignee_id: form.assignee_id }) };
    try { await api.put(`/crm/${entity}/${id}/assignment`, body); setMsg({ ok: "Saved. Recorded in the audit log.", err: "" }); onSaved?.(); }
    catch (x) { setMsg({ ok: "", err: errMsg(x) }); }
  };
  const pick = (key, label) => (
    <label htmlFor={`assign-${key}`} className="text-sm">{label}
      <select id={`assign-${key}`} value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} className={INPUT} data-testid={`assign-${key}`}>
        <option value="">Unassigned</option>
        {users.map((u) => <option key={u.id} value={u.id}>{u.display_name || u.id.slice(0, 8)} · {u.role_key}</option>)}
      </select>
    </label>
  );
  return (
    <form onSubmit={save} className="border border-erf-borderCream rounded bg-white p-4 grid gap-3 sm:grid-cols-4 sm:items-end" data-testid="assignment-card">
      {pick("owner_id", "Owner")}
      {pick("assignee_id", "Assigned to")}
      <label htmlFor="assign-priority" className="text-sm">Priority
        <select id="assign-priority" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className={INPUT} data-testid="assign-priority">
          {["low", "normal", "high", "urgent"].map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      </label>
      <button type="submit" className={`${BTN} bg-erf-gold text-erf-dark`} data-testid="assign-save">Save assignment</button>
      {msg.ok && <p role="status" className="text-sm text-green-800 sm:col-span-4" data-testid="assign-saved">{msg.ok}</p>}
      {msg.err && <p role="alert" className="text-sm text-red-700 sm:col-span-4" data-testid="assign-error">{msg.err}</p>}
    </form>
  );
}
